import React, { useEffect, useState } from 'react';
import { COPYWRIGHT_TEXT, FOOTER_LINK_1, FOOTER_LINK_2, FOOTER_LINK_3, RESET_PASSWORD_SUCCESS_BTN } from 'src/constants/constant';
import { useNavigate } from 'react-router-dom';
import commonService from 'src/services/commonService';

interface ProjectVersionResponse {
  version: string;
}

export default function PageNotFound(): JSX.Element {
  const navigate = useNavigate();
  const [PROJECT_VERSION, setProjectVersion] = useState<string>('');

  useEffect(() => {
    const ele: HTMLElement | null = document.getElementById('twilio-iframe-container');
    if (ele) ele.style.visibility = 'hidden';
    const eleBtn: HTMLElement | null = document.getElementById('twilio-iframe-button');
    if (eleBtn) eleBtn.style.visibility = 'hidden';

    commonService.getProjectVersion()
      .then((res: { data: ProjectVersionResponse }) => {
        setProjectVersion(`Version: ${res.data.version}`);
      })
      .catch(error => {
        console.error("Error fetching project version:", error);
      });
  }, []);

  const handleClick = (): void => {
    navigate('/');
  };

  return (
    <div className="min-h-screen flex flex-col justify-between bg-white">
      {/* Header aligned to the left */}
      <header>
  
        <img
          src='/assets/images/DataViewLogo.png'
          alt='logo'
          width={160}
          height={100}
          className='logo'
        />
      </header>

      {/* Horizontal Gray Line */}
      <div className="border-b w-full" style={{ borderColor: '#d3d3d3' }}></div>

      {/* Centered main content */}
      <main className="flex flex-1 items-center justify-center px-4">
        <div className="container max-w-[370px] mx-auto flex flex-col items-center text-center">
          <div className="login-header mb-[35px]">
            <img
              src='/assets/images/404.svg'
              alt='404'
              width={260}
              height={30}
              className='mx-auto'
            />
          </div>
          <h1 className="text-[20px] font-bold text-gray-800 mb-[10px]">
            Page not found
          </h1>
          <p className="text-subtitle text-[14px] mb-[35px] whitespace-nowrap">
            {"The page you've reached does not exist or is no longer available"}
          </p>
          <button
            onClick={handleClick}
            className="btn bg-gradient-to-b border-0 from-red to-primary h-[30px] w-[70%] text-14 capitalize focus-visible:outline-none rounded-50 font-semibold hover:from-[#D6242C] hover:to-[#ED4B52] text-white"
          >
            {RESET_PASSWORD_SUCCESS_BTN}
          </button>
        </div>
      </main>

      {/* Footer */}
      <footer className='w-full flex flex-col sm:flex-row justify-between items-center px-[50px] py-[20px] mt-auto bg-white'>
        <div className='flex justify-start sm:justify-center items-center mb-[10px] sm:mb-0'>
          <p className='text-muted2 text-12'>{COPYWRIGHT_TEXT}</p>
        </div>
        <div className='flex justify-center items-center mb-[10px] sm:mb-0'>
          <p className='text-muted2 text-12 sm:ml-[-20px]'>{PROJECT_VERSION}</p>
        </div>
        <div>
          <a
            href='https://www.healthlinkdimensions.com/website-terms'
            target='_blank'
            rel='noopener noreferrer'
            className='text-muted2 text-12 hover:text-primary pr-4 border-r border-muted2 pt-0 pb-0'
          >
            {FOOTER_LINK_1}
          </a>
          <a
            href='https://www.healthlinkdimensions.com/privacy-policy'
            target='_blank'
            rel='noopener noreferrer'
            className='text-muted2 text-12 hover:text-primary pr-4 pl-4 border-r border-muted2 pt-0 pb-0'
          >
            {FOOTER_LINK_2}
          </a>
          <a
            href='https://www.healthlinkdimensions.com/consumerprivacyrights'
            target='_blank'
            rel='noopener noreferrer'
            className='text-muted2 text-12 hover:text-primary pl-4'
          >
            {FOOTER_LINK_3}
          </a>
        </div>
      </footer>
    </div>
  );
}
